import { styled } from '@mui/material/styles';

export const HoverUnderline = styled('div')({
  cursor: 'pointer',
  '&:hover': { textDecoration: 'underline' },
});
